import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "@/lib/utils";
import { IoIcon } from "../Icons/IoIcon";
import { useUserStore } from "@/store/user";

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(({ className, orientation = "horizontal", decorative = true, ...props }, ref) => (
  <SeparatorPrimitive.Root
    ref={ref}
    decorative={decorative}
    orientation={orientation}
    className={cn(
      "shrink-0 bg-border",
      orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      className
    )}
    {...props}
  />
));
Separator.displayName = SeparatorPrimitive.Root.displayName;

interface LogoSeparatorProps {
  iconClassName?: string;
  className?: string;
}

const LogoSeparator = ({ iconClassName = "", className }: LogoSeparatorProps) => {
  const theme = useUserStore((state) => state.theme);

  return (
    <Separator className={cn("flex flex-row items-center justify-center", className)}>
      <div className="flex flex-row items-center justify-center bg-container px-2 dark:bg-black">
        <IoIcon
          className={cn("h-[10px] text-black dark:text-gray-dark-900", iconClassName)}
          inheritColor={theme === "light"}
        />
      </div>
    </Separator>
  );
};

export { Separator, LogoSeparator };
